import * as http from 'axios'

export const getPedidosCliente = (idCliente) => {
  return http.get(`/pedidos?cliente=${idCliente}`)
}
export const getPedidosUnidade = (idUnidade) => {
  return http.get(`/pedidos?unidade=${idUnidade}`)
}
export const save = (pedido) => http.post('/pedidos', pedido)
export const get = (id) => http.get(`/pedidos/${id}?populate=unidade cupom`)
export const update = (id, pedido) => http.put(`/pedidos/${id}`, pedido)
export const aplicarCupom = (payload) => http.post('/cupom', payload)



// WEBPACK FOOTER //
// ./src/store/pedido/services.js